import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es7.array.includes";
import "core-js/modules/web.dom.iterable";
/*
 * @Author: wangyang
 * @Date: 2021-03-29 13:25:58
 * @LastEditors: wangyang
 * @LastEditTime: 2021-04-14 16:30:07
 * @Description: 角色数据
 */
import { asyncRoutes, constantRoutes } from '@/router';
import user from "./user.js";
import Layout from '@/layout';
import store from "../../store";
function getAsyncRoutes(routes) {
  var res = [];
  var keys = ['path',
  // 'name',
  'children', 'title',
  // 'redirect',
  // 'alwaysShow',
  'meta'
  // 'hidden'
  ];
  routes.forEach(function (item) {
    var newItem = {};
    if (item.component) {
      if (item.component === 'Layout') {
        newItem.component = Layout;
      } else {
        item.component = item.component.slice(8);
        newItem.component = function (resolve) {
          return require(["@/views/".concat(item.component)], resolve);
        };
        console.log(process.env.VUE_APP_BASE_API);
      }
      // newItem.hidden = false
    }
    if (!item.meta) {
      item.meta = {
        title: item.title
      };
    }
    if (item.jump_path == 2) {
      item.path = process.env.VUE_APP_BASE_API + item.path.slice(1) + '?token=' + store.getters.token;
    }
    // 销售方案
    if (item.path == '/gift-pack/sell/schemeManage/index' || item.path == '/gift-pack/sell/goodsWarehouse/index' || item.path == '/gift-pack/sell/goodsWarehouse/indexcli') {
      item.meta.source = 'sell';
    }
    if (item.path == '/gift-pack/operation/schemeManage/index' || item.path == '/gift-pack/operation/goodsWarehouse/index' || item.path == '/gift-pack/sell/goodsWarehouse/indexcli') {
      item.meta.source = 'operation';
    }
    for (var key in item) {
      if (keys.includes(key)) {
        newItem[key] = item[key];
        // if (key == 'title') newItem['meta'].title = item[key]
      }
      // newItem['name'] = item['path']
    }
    if (newItem.children && newItem.children.length) {
      newItem.children = getAsyncRoutes(item.children);
    }
    res.push(newItem);
  });
  return res;
}

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, roles) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      var accessedRoutes2;

      // if (roles.includes('admin')) {
      //   accessedRoutes = asyncRoutes || []
      // } else {
      // accessedRoutes2 = filterAsyncRoutes(asyncRoutes, roles)
      accessedRoutes = getAsyncRoutes(user.state.menus);

      // }
      console.log(accessedRoutes, 'accessedRoutes');
      // console.log(accessedRoutes2, 'accessedRoutes2')

      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};